import { motion } from 'framer-motion';

const logos = [
  { name: 'TechCrunch', width: 'w-32' },
  { name: 'Forbes', width: 'w-24' },
  { name: 'Wired', width: 'w-28' },
  { name: 'The Verge', width: 'w-32' },
  { name: 'Mashable', width: 'w-28' },
];

export default function FeaturedInStrip() {
  return (
    <section className="py-12 bg-gray-50 border-y border-gray-100">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-6">
            As Featured In
          </p>
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
            {logos.map((logo, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className={`${logo.width} h-8 flex items-center justify-center`}
              >
                <div className="text-gray-300 font-bold text-lg tracking-tight">
                  {logo.name}
                </div>
              </motion.div>
            ))}
          </div>
          <p className="text-xs text-gray-400 mt-6 italic">
            * Placeholder for future press mentions
          </p>
        </motion.div>
      </div>
    </section>
  );
}